<template>
  <div>
    <div class="mb-3 richmenu-head">
      <div class="text-center richmenu-head-text">Contact</div>
    </div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 50px; padding-top: 0px">
        <v-img
          style="margin-left: auto; margin-right: auto"
          width="80px"
          src="../../assets/depa.png"
        ></v-img>
      </div>

      <v-container>
        <div style="font-size: 24px; font-weight: 600">Contact</div>
        <v-select
          :value="'สำนักงานใหญ่'"
          outlined
          dense
          v-model="selectedContact"
          :hide-details="true"
          item-text="label"
          item-value="value"
          :items="contactOptions"
        ></v-select>

        <v-component :is="selectedContact"></v-component>
      </v-container>
    </div>
  </div>
</template>

<script>
import DepaCenter from "./Contacts/Depacenter.vue";
import Phuket from "./Contacts/Phuket.vue";
import Hadyai from "./Contacts/Hadyai.vue";
import Chiangmai from "./Contacts/Chiangmai.vue";
import Phitsanulok from "./Contacts/Phitsanulok.vue";
import Cholburi from "./Contacts/Cholburi.vue";
import Khonkaen from "./Contacts/Khonkaen.vue";
import Ubon from "./Contacts/Ubon.vue";
export default {
  components: {
    DepaCenter,
    Phuket,
    Hadyai,
    Chiangmai,
    Phitsanulok,
    Cholburi,
    Khonkaen,
    Ubon,
  },
  data() {
    return {
      tab: "event",
      selectedContact: "DepaCenter",
      contactOptions: [
        {
          label: "สำนักงานใหญ่",
          value: "DepaCenter",
        },
        {
          label: "ภูเก็ต",
          value: "Phuket",
        },
        {
          label: "หาดใหญ่",
          value: "Hadyai",
        },
        {
          label: "เชียงใหม่",
          value: "Chiangmai",
        },
        {
          label: "พิษณุโลก",
          value: "Phitsanulok",
        },
        {
          label: "ชลบุรี",
          value: "Cholburi",
        },
        {
          label: "ขอนแก่น",
          value: "Khonkaen",
        },
        {
          label: "อุบลราชธานี",
          value: "Ubon",
        },
      ],
    };
  },
  mounted() {
    if (this.query.contact) {
      this.selectedContact = this.query.contact;
    }
  },
};
</script>

<style lang="scss" >
notActiveEvent {
  color: #152d53;
  font-weight: 900 !important;
}
.richmenu-head {
  height: 60px;
  background-color: #152d53;
  display: flex;
  justify-content: center;
}
.richmenu-head-text {
  line-height: 22px;
  font-size: 27px;
  font-weight: 400;
  color: white;
  align-self: center;
  word-break: break-word;
}
</style>